import DatosEmpresa from 'components/empresa/DatosEmpresa'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewDatosEmpresa = () => {
  return (
    <Row>
        <Col> <DatosEmpresa></DatosEmpresa> </Col>
    </Row>
  )
}

export default ViewDatosEmpresa